/**
 * Routes
 */
/* eslint-disable */
import { PermissionsComponent } from 'components/AsyncComponent';
import { Layout, Section } from 'layout';
import { Redirect, Route, Switch } from 'react-router-dom';

const Forms = ({ match }) => {
  return (
    <Layout type={'sidebar_page_layout'}>
      <Section name={'content'}>
        <Switch>
          <Route path={`${match.url}/`} component={PermissionsComponent} />
          <Route path='*' render={() => <Redirect to='/404' />} />
        </Switch>
      </Section>
    </Layout>
  );
};

export default Forms;
